
import Vue from 'vue'

import { RButton, RInput } from '@/components'
import { mapActions, mapGetters } from 'vuex'
import { isAlreadyPending } from '@/store/root'
import { formatPriceFromCents } from '@/services/prices'

type CreditsPurchaseData = {
  credits: number
}

type PowerOption = {
  label: string
  price: string
}

type HoursLine = {
  power: string
  price: string
  hours: number
}

export default Vue.extend({
  name: 'AddCredits',
  data(): CreditsPurchaseData {
    return {
      credits: 10,
    }
  },
  components: {
    RButton,
    RInput,
  },
  methods: {
    ...mapActions({
      addCredits: 'payment/addCredits',
    }),

    async handlePurchase() {
      const { creditsCents } = this
      if (!creditsCents) return
      await this.addCredits(creditsCents)
    },
  },
  computed: {
    ...mapGetters({
      addCreditsRequest: 'payment/addCreditsRequest',
      isUserOnTrial: 'user/isUserOnTrial',
    }),
    creditsUsd(): string {
      return formatPriceFromCents(this.creditsCents)
    },
    creditsCents(): number {
      return this.credits * 100
    },
    powerOptions(): Array<PowerOption> {
      return [
        { label: 'Basic', price: '1.99' },
        { label: 'Medium', price: '2.99' },
        { label: 'Advanced', price: '4.99' },
        { label: 'Turbo', price: '9.99' },
      ]
    },
    addCreditsRequestPending(): boolean {
      return isAlreadyPending(this.addCreditsRequest)
    },
    purchaseButtonDisabled(): boolean {
      return !this.creditsCents || this.addCreditsRequestPending || this.error
    },
    error(): boolean {
      if (!this.credits) {
        return false
      }
      const num = +this.credits
      const ok = Number.isInteger(num) && num >= 10 && num <= 1000
      return !ok
    },
    hours(): HoursLine[] {
      return [
        {
          power: 'Basic',
          price: '$1.99/h',
          hours: Math.round(this.creditsCents / 199),
        },
        {
          power: 'Medium',
          price: '$2.99/h',
          hours: Math.round(this.creditsCents / 299),
        },
        {
          power: 'Advanced',
          price: '$4.99/h',
          hours: Math.round(this.creditsCents / 499),
        },
        {
          power: 'Turbo',
          price: '$9.99/h',
          hours: Math.round(this.creditsCents / 999),
        },
      ]
    },
  },
})
